/* istanbul ignore file */
import React from 'react';
import { EnumField, FieldProps } from 'framework/ui/field';
import { ASSET_STATUS_OPTIONS } from '../../useAssetService';

const AssetStatusField = (props: FieldProps) => {
  return <EnumField options={ASSET_STATUS_OPTIONS} {...props} />;
};

export default AssetStatusField;
